import { useUpdateMutation } from "../api/genericHooks";
import { Language } from "../types/models/Language";

export const useUserLanguage = (userId: number | undefined) => {
  const updateUserMutation = useUpdateMutation({
    route: "/users/:id",
    pathParams: { id: userId },
  });

  const updateUserLanguage = async (language: Language) => {
    if (!userId) {
      console.error("User ID is required to update language");
      return;
    }

    try {
      const response = await updateUserMutation.mutateAsync({
        user: {
          language_id: language.id,
        },
      });
      return response;
    } catch (error) {
      console.error("Failed to update user language:", error);
      throw error;
    }
  };

  return {
    updateUserLanguage,
    isLoading: updateUserMutation.isLoading,
    isError: updateUserMutation.isError,
    error: updateUserMutation.error,
  };
};
